import React, { useState } from "react";
import { request } from "../services/utils";
import "./login.css";
import { useNotification } from "../contexts/NotificationContext";

export default function ForgotPassword({ history }) {
    const [isFetching, setIsFetching] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [email, setEmail] = useState("");
    const { createErrorNotification } = useNotification();

    function handleSubmit(event) {
        event.preventDefault();
        setIsFetching(true);
        request
            .post("/api/passwords", { emailAddress: email })
            .then(() => setSubmitted(true))
            .catch((error) => {
                createErrorNotification(`Error: ${error?.normalizedMessage}. Try again or contact us.`);
            })
            .finally(() => setIsFetching(false));
    }

    return (
        <div className="card">
            {submitted ? (
                <p className="sign" align="center">
                    Check your email for a password reset link.
                </p>
            ) : (
                <>
                    <p className="sign" align="center">Forgot Password</p>
                    <p align="center">Enter your email</p>
                    <form onSubmit={handleSubmit} className="form1" id="forgot-form" autoComplete="on">
                        <input
                            id="forgot-form_email-input"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            name="email"
                            className="un"
                            type="email"
                            align="center"
                            disabled={isFetching}
                            placeholder="Email"
                            autoComplete="username"
                            required
                        />
                        {isFetching ? (
                            <p className="please-wait-text">Please wait...</p>
                        ) : (
                            <button type="submit" value="reset" id="submit" className="submit" align="center">
                                Send Reset Link
                            </button>
                        )}
                    </form>
                </>
            )}
            <button disabled={isFetching} onClick={() => history.push("/login")} className="forgotpw" align="center">
                Go back to Login
            </button>
        </div>
    );
}
